import React from 'react';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import PhoneIcon from '@material-ui/icons/Phone';
import BackupIcon from '@material-ui/icons/Backup';

const useStyles = makeStyles({
  icon: {
    color: '#fff',
    fontSize: 20
  },
});

const TouchpointIcon = ({ size, type, theme }) => {
    const classes = useStyles();

    return (
        <Box
            display="flex" 
            alignItems="center" 
            justifyContent="center" 
            bgcolor={`${lighten(theme ? '#4f6172': '#ADB9D7', 0.1)}`} 
            height={size || 30} 
            width={size || 30} 
            borderRadius="50%"
        >
            { type === "text"
              ? <BackupIcon className={classes.icon}/>
              : <PhoneIcon className={classes.icon}/>
            }
            
        </Box>
    );
}

export default TouchpointIcon;